module.exports = true;



//////////////////
// WEBPACK FOOTER
// ./~/react-input-calendar/~/core-js/library/modules/_library.js
// module id = 232
// module chunks = 3